import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';

import { useFilters } from '../FiltersState';

import { FiltersCarrier } from './FiltersCarrier';
import { FiltersDestination } from './FiltersDestination';
import { FiltersOrigin } from './FiltersOrigin';
import { FiltersSortBy } from './FiltersSortBy';
import { FiltersStep } from './FiltersStep';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({ id: 'shipments.filters.search.label', message: 'Search shipments' })}
        placeholder={t({
          id: 'shipments.filters.search.placeholder',
          message: 'Search shipments...',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <FiltersStep />
        <FiltersCarrier />
        <FiltersOrigin />
        <FiltersDestination />
        <FiltersSortBy />
      </FiltersDrawer>
    </Stack>
  );
};
